/**
 * Mirrors backend `User::canAccessPlatformPermission` using the flat permission list from `GET /me`.
 */
export function canAccessPlatformPermission(granted: string[], required: string): boolean {
    for (const key of granted) {
        if (key === required) return true;
        if (key.endsWith("*")) {
            const prefix = key.slice(0, -1);
            if (required.startsWith(prefix)) return true;
        }
    }
    return false;
}

/** Literal match only — for role-scoped pages a wildcard grant (e.g. owner `*`) must not qualify. */
export function hasExactPermission(granted: string[], required: string): boolean {
    return granted.includes(required);
}

export const ASSOCIATE_DASHBOARD_PERMISSION = "associate.dashboard:read";
